var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsertDriveFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.87 10.5H12.13V4.75L17.87 10.5Z",
    fill: "#2445A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4599 11.42V18.42C18.4637 18.605 18.4302 18.7888 18.3615 18.9606C18.2928 19.1324 18.1902 19.2886 18.0599 19.42C17.9287 19.5512 17.7728 19.655 17.6011 19.7254C17.4294 19.7958 17.2455 19.8313 17.0599 19.83H6.91994C6.7344 19.8313 6.55045 19.7958 6.37878 19.7254C6.20711 19.655 6.05114 19.5512 5.91994 19.42C5.78963 19.2886 5.68707 19.1324 5.61836 18.9606C5.54964 18.7888 5.51617 18.605 5.51994 18.42V5.53998C5.51617 5.35499 5.54964 5.17114 5.61836 4.99935C5.68707 4.82755 5.78963 4.67134 5.91994 4.53998C6.05114 4.40878 6.20711 4.30498 6.37878 4.23459C6.55045 4.16421 6.7344 4.12865 6.91994 4.12998H11.2099V11.4L18.4599 11.42Z",
    fill: "#2445A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertDriveFileIcon);
export default __webpack_public_path__ + "static/media/InsertDriveFileIcon.4f29a7281e7d960e2f887fcf419d9f2b.svg";
export { ForwardRef as ReactComponent };